import { UserPermissionsConstants } from '../Constants';
import { adminUsersServices } from '../Services';
import myadminPermissions from '../../container/Layout/adminPermssion.json';

export const  UserPermssions = {
    UserPermssion,
};

function UserPermssion(role:any) {
    return (dispatch:any) => {
        // dispatch(dispatchFunction({
        //     type: UserPermissionsConstants.USER_PERMISSIONS_REQUEST,
        //     data: null
        // }));
        if(parseInt(role) === 1){
            var data = {data:myadminPermissions}
            dispatch(dispatchFunction({
                type: UserPermissionsConstants.USER_PERMISSIONS_SUCCESS,
                data: data
            })); 
        }
        if(role === 2){
            adminUsersServices.UserPermssion(role)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: UserPermissionsConstants.USER_PERMISSIONS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: UserPermissionsConstants.USER_PERMISSIONS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: UserPermissionsConstants.USER_PERMISSIONS_FAILURE,
                        data: error.message
                    }));
                }
            );
        }
    };
}


function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}